import {Component} from "@angular/core";
import {DICTIONARY} from "../../../../dictionary";
import {RouteService} from "../../../../services/routeService";


@Component({
	selector: 'collaboration-protection-not-supported',
	templateUrl: './collaboration-not-supported.component.html',
	styleUrls: ['./collaboration-not-supported.component.scss']
})
export class CollaborationNotSupportedComponent {

	dic = DICTIONARY;
	startingTrial = false;

	constructor(private rs: RouteService) {
	}

	startFreeTrial() {
		this.startingTrial = true;
		this.rs.enableCollaborationFreeTrial().then(() => {
			window.location.reload();
		}).catch(() => {
			this.startingTrial = false;
		});
	}
}
